import React, { memo, useState } from 'react'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { getPaletteColor } from 'pcln-design-system'
import get from 'lodash.get'
import usePartner from '../../hooks/usePartner'
import NavLink from '../NavLink'

const Container = styled.footer`
  background-color: ${props => getPaletteColor(props.backgroundColor)(props)};
  color: ${props => getPaletteColor(props.color)(props)};
  z-index: 1500;
  -webkit-font-smoothing: initial;
  -moz-osx-font-smoothing: initial;
  font-size: ${themeGet('fontSizes.1')}px;
  padding: 0 ${themeGet('space.2')}px;
`
Container.displayName = 'Container'

const Content = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-flow: row wrap;
`

const Section = styled.div`
  flex: 1;
  padding: ${themeGet('space.3')}px;
  line-height: 27px;
  min-width: 180px;
`

const Heading = styled.div`
  font-weight: bold;
  font-size: ${themeGet('fontSizes.2')}px;
`

function Footer () {
  const [showCCPALink, setShowCCPALink] = useState(false)
  const footerConfig = usePartner('config.footer')
  const navigation = get(footerConfig, 'navigation', [])
  const backgroundColor = get(footerConfig, 'backgroundColor', '#fefefe')
  const color = get(footerConfig, 'color', '#001833')

  // check if the footer should only render for CCPA
  const renderForCCPA = get(footerConfig, 'renderForCCPA', false)

  function checkCCPA () {
    const isOneTrustLoaded = window.OneTrust != null
    const location =
      isOneTrustLoaded &&
      typeof window.OneTrust.getGeolocationData === 'function' &&
      window.OneTrust.getGeolocationData()
    const oneTrustLocationCheck =
      location && location.country === 'US' && location.state === 'CA'

    setShowCCPALink(isOneTrustLoaded && oneTrustLocationCheck)
  }

  React.useEffect(() => {
    window.addEventListener('load', checkCCPA)

    return () => {
      window.removeEventListener('load', checkCCPA)
    }
  }, [])

  return !renderForCCPA || (renderForCCPA && showCCPALink) ? (
    <Container
      id='global-footer'
      backgroundColor={backgroundColor}
      color={color}
    >
      <Content>
        {navigation.map(section => (
          <Section>
            <Heading>{section.title}</Heading>
            {section.content.map(
              content =>
                ((content.isCCPALink && showCCPALink) ||
                  !content.isCCPALink) && (
                  <NavLink
                    {...content}
                    className={
                      content.isCCPALink
                        ? 'optanon-toggle-display'
                        : content.className
                    }
                    color={content.color || color}
                    target={content.target}
                  />
                )
            )}
          </Section>
        ))}
      </Content>
    </Container>
  ) : null
}

Footer.displayName = 'Footer'

export default memo(Footer)
